export const AppEnvironments = {
  DEVELOPMENT: 'development',
  PRODUCTION: 'production',
  INTEGRATION: 'integration',
  STAGING: 'staging',
  TESTING: 'testing',
};
